import * as React from 'react'

import cn from 'classnames/bind'

import styles from './index.module.scss'

export type Types = 'brand' | 'primary' | 'radical' | 'negative' | 'wrong' | 'darker' | 'accent'
type Sizes = 'small' | 'medium'
interface Props {
  compact?: boolean
  color?: string
  size?: Sizes
  type?: Types
}

const cx = cn.bind(styles)

const Separator = ({ color, size = 'medium', type = 'radical', compact }: Props) => {
  return (
    <div
      style={
        color
          ? {
              borderColor: color,
            }
          : {}
      }
      className={cx('separator', size, type, {
        compact,
      })}
    />
  )
}

export default Separator
